import { render, staticRenderFns } from "./organizations-by-region-labels.vue?vue&type=template&id=3db9cb48&scoped=true&"
import script from "./organizations-by-region-labels.vue?vue&type=script&lang=js&"
export * from "./organizations-by-region-labels.vue?vue&type=script&lang=js&"
import style0 from "./organizations-by-region-labels.vue?vue&type=style&index=0&id=3db9cb48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9cb48",
  null
  
)

export default component.exports